import {KpiCalculationError} from '@hconnect/common/types'

import {MONTH_MAP} from '../consts'
import {MtmKpiValue, MonthDataColumns, HierarchyTableNode, DailyKpiValue, MonthData} from '../types'

export function mapMonthsData(data: MtmKpiValue[]): MonthDataColumns {
  const result: MonthDataColumns = Object.create(null)
  data.forEach((item) => {
    const {hierarchyId, month, ...rest} = item
    const monthKey = MONTH_MAP[month.split('-')[1]]
    if (!result[hierarchyId]) result[hierarchyId] = {}
    result[hierarchyId][monthKey] = {
      ...rest,
      value: rest.value === undefined ? undefined : Math.round(rest.value)
    }
  })
  return result
}

export const mapDailyKpiValuesToNodes = (
  nodes: HierarchyTableNode[],
  dailyValues: DailyKpiValue[]
): HierarchyTableNode[] => {
  const valuesByNodeAndDay = dailyValues.reduce<Record<string, Record<string, MonthData>>>(
    (acc, kpi) => {
      acc[kpi.hierarchyId] ??= {}
      acc[kpi.hierarchyId][kpi.day] = {
        value: kpi.value === undefined ? undefined : Math.round(kpi.value),
        isEditedManually: kpi.isEditedManually,
        isDirty: kpi.isDirty,
        kpiCalculationError: kpi.kpiCalculationError as KpiCalculationError | undefined,
        hasComments: kpi.hasComments
      }
      return acc
    },
    {}
  )

  const mergeNode = (node: HierarchyTableNode): HierarchyTableNode => ({
    ...node,
    ...valuesByNodeAndDay[node.id],
    subItems: node.subItems?.map(mergeNode)
  })

  return nodes.map(mergeNode)
}
